/* Armadio di Sofia · contador de la franja de arriba del carrito (snippets/cl-carrello-timer.liquid).
   Empieza con la primera prenda y vuelve a empezar cada vez que se añade otra (o se sube la cantidad).
   El final se guarda en el navegador: recargar no lo reinicia y no vuelve a empezar en bucle.
   Al llegar a 00:00 se quita el contador y queda solo el texto hasta que añada algo.
   Carrito vacío → se borra y el siguiente empieza de cero.
   1 nov 2026: claves nuevas (_2) para olvidar las cuentas viejas del 28 oct, y si acabó hace más de 30 min,
   la siguiente vez que abra el carrito empieza otra vez (si no, quien vuelve otro día no lo ve nunca).
   Se mira cada segundo porque el carrito se vuelve a pintar entero en cada cambio. */
(function () {
  var KEY = 'cl_timer_fine_2';
  var KEY_N = 'cl_timer_n_2';
  var DESCANSO = 30 * 60000; // 30 min después de acabar, vuelve a empezar
  var mem = {}; // por si el navegador no deja guardar

  function leer(k) { try { var v = localStorage.getItem(k); return v === null ? (mem[k] || 0) : Number(v) || 0; } catch (e) { return mem[k] || 0; } }
  function guardar(k, v) { mem[k] = v; try { localStorage.setItem(k, String(v)); } catch (e) {} }
  function borrar() { mem = {}; try { localStorage.removeItem(KEY); localStorage.removeItem(KEY_N); } catch (e) {} }
  function dos(n) { return (n < 10 ? '0' : '') + n; }

  // Prendas en el carrito lateral (suma de cantidades)
  function prendas() {
    var inputs = document.querySelectorAll('#CartDrawer .cart-item .quantity__input');
    var n = 0;
    for (var i = 0; i < inputs.length; i++) n += Number(inputs[i].value) || 0;
    return n;
  }

  function tick() {
    if (document.querySelector('.cl-cart-timer-reset')) borrar();
    var cajas = document.querySelectorAll('.cl-cart-timer');
    if (!cajas.length) return;

    var minuti = Number(cajas[0].getAttribute('data-minuti')) || 5;
    var n = prendas();
    var fine = leer(KEY);
    if (!fine || (n && n > leer(KEY_N)) || Date.now() - fine > DESCANSO) {
      fine = Date.now() + minuti * 60000; // primera prenda o prenda nueva: 5 minutos otra vez
      guardar(KEY, fine);
    }
    if (n) guardar(KEY_N, n);

    var resto = Math.max(0, Math.round((fine - Date.now()) / 1000));
    for (var i = 0; i < cajas.length; i++) {
      var caja = cajas[i];
      caja.classList.toggle('is-finito', resto <= 0);
      caja.classList.toggle('is-ultimo', resto > 0 && resto <= 60);
      var t = caja.querySelector('.cl-cart-timer__tempo');
      if (t && resto > 0) t.textContent = dos(Math.floor(resto / 60)) + ':' + dos(resto % 60);
    }
  }

  tick();
  setInterval(tick, 1000);
})();
